export type TrackingParameterValue = string | string[] | number | undefined;

export type TrackingParameterKeys =
  | 'event'
  | 'h_page_type_110'
  | 'h_page_subtype_112'
  | 'h_content_language_116'
  | 'h_search_term_geo_080'
  | 'h_number_of_search_terms_entered_278'
  | 'h_list_name_086'
  | 'h_srp_items_loaded_078'
  | 'h_search_offer_type_083'
  | 'h_search_results_loaded_279'
  | 'h_search_results_total_280'
  | 'h_search_results_pages_all_287'
  | 'h_search_results_page_current_288'
  | 'h_event_category_006'
  | 'h_event_action_007'
  | 'h_list_items_all_087'
  | 'h_list_items_total_284'
  | 'h_list_items_loaded_088'
  | 'h_list_items_loaded_285'
  | 'h_event_label_008'
  | 'h_list_item_clicked_id_085'
  | 'h_position_on_list_overall_283'
  | 'h_search_sorted_details_073';

export type TrackingEventParams = Partial<Record<TrackingParameterKeys, TrackingParameterValue>>;

export enum InteractionEvent {
  LOAD = 'virtual_pageview',
  GENERIC_INTERACTION = 'generic_interaction',
  HEADER_INTERACTION = 'header_interaction',
  FOOTER_CLICK = 'footer_interaction',
  LIST_LOAD = 'list_load',
  SUBMIT_SEARCH = 'submit_search',
  LIST_CLICKTHROUGH = 'list_clickthrough',
  SEARCH_SORT = 'search_sort',
  BUTTON_CLICK = 'button_click',
}

export enum PageType {
  AGENCY_DIRECTORY = 'agency_directory',
  AGENT_DIRECTORY = 'agent_directory',
}

export enum InteractionGoal {
  OPEN_FAVOURITES = 'open_favourites',
}

export enum EventLabel {
  TAB_NAVIGATION = 'tab_navigation',
}

export enum SortingOptionEventLabel {
  ALPHABET_ASC = 'alphabet-asc',
  TOTALRENTADS_DESC = 'totalrentads-desc',
  TOTALRENTADS_ASC = 'totalrentads-asc',
  TOTALSALEADS_DESC = 'totalsaleads-desc',
  TOTALSALEADS_ASC = 'totalsaleads-asc',
  COMPLETENESS_DESC = 'completeness-desc',
}
